import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-item-tradesmen.component.scss';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from "jquery";
import "bootstrap-datepicker";
var FormItemTradesmen = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemTradesmen, _super);
    function FormItemTradesmen(element) {
        return _super.call(this, element) || this;
    }
    FormItemTradesmen.prototype.init = function () {
        this.applyForm = this.element.querySelector("form");
        this.applyFormSubmit = Array.from(this.element.querySelectorAll(".js_submit-button"));
        if (this.applyForm) {
            this.displayLoader = this.applyForm.querySelector(".form-container__loader");
            this.displayFields = this.applyForm.querySelector(".form-container__fields");
            this.displaySuccess = this.applyForm.querySelector(".form-container__success");
            this.displayFail = this.applyForm.querySelector(".form-container__error");
        }
        this.containerModal = this.element.closest('.form-item-tradesmen');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        this.backButton = this.containerModal.querySelector('.js_back-button');
        this.formDatePicker = this.element.querySelector('.js-date-picker');
        this.formTimePicker = this.element.querySelector('.js-time-picker');
        this.identificationSelection = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        this.initFieldLengths();
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea = this.element.querySelector(".data-sharing-sms");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        if ((typeof dataLayer != 'undefined')) {
            dataLayer.application.applicationName = "callmeback mymobiz and simplyblu for tradesmen";
        }
        // calender
        this.publicHolidays = ['2025/01/01', '2025/03/21', '2025/03/30', '2025/04/02', '2025/04/27', '2025/05/01', '2025/06/16', '2025/08/09', '2025/09/24', '2025/12/16', '2025/12/17', '2025/12/25', '2025/12/26'];
        this.populateDatePicker();
    };
    // populating the current date picker
    FormItemTradesmen.prototype.populateDatePicker = function () {
        var _this = this;
        this._startDate = this.validateDate();
        var nextYear = new Date().getFullYear() + 1;
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker({
                startDate: this._startDate,
                format: 'yyyy/mm/dd',
                daysOfWeekDisabled: [0, 6],
                datesDisabled: this.publicHolidays,
                endDate: new Date(nextYear, 11, 31),
            });
            $(this.formDatePicker).change(function () {
                _this.formDatePicker.dispatchEvent(new Event('blur', {}));
            });
        }
    };
    FormItemTradesmen.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== 'Anytime') {
                if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
                    item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    FormItemTradesmen.prototype.bindEvents = function () {
        var _this = this;
        // Calender
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener('change', function (event) {
                _this.validateDate(event.target);
            });
        }
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
        this.applyFormSubmit.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        if (this.backButton) {
            this.backButton.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm(); });
        }
        // Reset the form
        this.applyForm.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
        if (this.applyForm) {
            var _formFields = Array.from(this.applyForm.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.element.querySelector('input[name=business-reg-number]').addEventListener('input', function (e) {
            var value = e.target.value;
            // Remove all non-numeric characters
            value = value.replace(/[^0-9]/g, '');
            // Apply the formatting
            if (value.length > 10) {
                value = value.slice(0, 4) + '/' + value.slice(4, 10) + '/' + value.slice(10, 12);
            }
            else if (value.length > 4) {
                value = value.slice(0, 4) + '/' + value.slice(4);
            }
            e.target.value = value;
        });
    };
    FormItemTradesmen.prototype.initFieldLengths = function () {
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        _firstName.setAttribute("maxlength", "80");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        _surname.setAttribute("maxlength", "80");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNo]");
        _contactNumber.setAttribute("maxlength", "10");
    };
    FormItemTradesmen.prototype.validSAContact = function (field) {
        var is_zero_number_correct = true;
        var num;
        num = /^0[0-9]\d{8}$/g;
        if (num.test(field.value) === false) {
            is_zero_number_correct = false;
        }
        else {
            is_zero_number_correct = true;
        }
        return is_zero_number_correct;
    };
    FormItemTradesmen.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.remove("active");
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.remove("active");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.remove("active");
        this.displaySuccess.classList.add("hidden");
        this.displayFail.classList.remove("active");
        this.displayFail.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.add("active");
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.add("active");
                this.displaySuccess.classList.remove("hidden");
                break;
            case "fail":
                this.displayFail.classList.add("active");
                this.displayFail.classList.remove("hidden");
                break;
            default:
                this.displayLoader.classList.add("active");
                this.displayLoader.classList.remove("hidden");
                break;
        }
    };
    FormItemTradesmen.prototype.closeForm = function () {
        var baseUrl = '/southafrica/business/campaigns/tradesman-solutions';
        window.location.href = baseUrl;
    };
    FormItemTradesmen.prototype.resetForm = function () {
        if (this.applyForm) {
            this.applyForm.reset();
            this.showDisplayView("fields");
        }
    };
    FormItemTradesmen.prototype.submitForm = function (form) {
        var _this = this;
        var _displayName = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var analyticsService = new AnalyticsService();
        var _firstName = this.applyForm.querySelector("input[name=firstName]");
        var _surname = this.applyForm.querySelector("input[name=surname]");
        var _contactNumber = this.applyForm.querySelector("input[name=contactNo]");
        var _email = this.applyForm.querySelector("input[name=emailAddress]");
        var _recipient = this.applyForm.querySelector("input[name=recipient]");
        var _mailBoxEmail = this.applyForm.querySelector("input[name=email]");
        var _businessName = this.applyForm.querySelector("input[name=business-name]");
        var _date = this.applyForm.querySelector("input[name=date]");
        var _time = this.applyForm.querySelector("select[name=time]");
        var _businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var _solutions = form.querySelectorAll("input[name=solution]");
        var _solution = form.querySelector("input[name=solution]");
        var _popiConsent = this.applyForm.querySelector("input[name=popia-consent]");
        var errors = [];
        var errors1 = [];
        var selectedValues = [];
        _solutions.forEach(function (checkbox) {
            if (checkbox.checked) {
                selectedValues.push(checkbox.value);
            }
        });
        var selections = Array.from(_solutions).map(function (checkbox) { return checkbox.checked ? checkbox.value : ""; });
        if (_contactNumber.value.length != 10) {
            errors.push('South African contact numbers are 10 digits');
        }
        if (!this.validSAContact(_contactNumber)) {
            errors.push('This contact number is invalid');
        }
        if (selectedValues.length === 0) {
            errors1.push('Please select at least one solution');
        }
        if (errors.length !== 0) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            this.validationService.addErrorMessage(_contactNumber, errors);
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        if (errors1.length !== 0) {
            this.showDisplayView('fields');
            analyticsService.dtmFormComplete("complete", "false");
            this.validationService.addErrorMessage(_solution, errors1);
            window.scroll({ top: 0, behavior: "smooth" });
            return;
        }
        var _postData = {
            subject: "MyMoBiz and SimplyBLU for Tradesmen",
            product: "MyMoBiz and SimplyBLU for Tradesmen",
            firstName: (_firstName ? _firstName.value : ""),
            surname: (_surname ? _surname.value : ""),
            emailAddress: (_email ? _email.value : ""),
            email: (_recipient ? _recipient.value : "ClientExperienceAcquisitionLabInitiative@standardbank.co.za"),
            recipient: (_mailBoxEmail ? _mailBoxEmail.value : "ClientExperienceAcquisitionLabInitiative@standardbank.co.za"),
            contactNo: (_contactNumber ? _contactNumber.value : ""),
            businessName: (_businessName ? _businessName.value : ""),
            businessRegNumber: (_businessRegNumber ? _businessRegNumber.value : ""),
            solution: (_solutions ? selections.join(": ") : ": : "),
            bestTimeToCall: (_date ? _date.value : "") + " " + (_time ? _time.value : ""),
            dataPrivacyConsent: ((_popiConsent && _popiConsent.checked) ? "YES" : "NO"),
            dataSharingGroup: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-group'),
            dataSharing3rdParty: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-3rd-party'),
            dataSharingBoarders: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-boarders'),
            dataSharingTelesale: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-telesale'),
            dataSharingEmail: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-email'),
            dataSharingSms: this.dataConsentService.getDataConsentValue(this.applyForm, 'data-sharing-sms'),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/save-tradesman-solution";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            var _response = response.data;
            if (_response.toString().includes('invalid')) {
                analyticsService.dtmFormComplete("complete", "false");
                _this.showDisplayView("fail");
            }
            else {
                if (_displayName) {
                    _displayName.map(function (pElement) {
                        pElement.innerHTML = _postData.firstname;
                    });
                }
                analyticsService.dtmFormComplete("complete", "true");
                _this.showDisplayView("success");
                window.scroll({ top: 0, behavior: "smooth" });
            }
        }).catch(function (response) {
            analyticsService.dtmFormComplete("complete", "false");
            this.showDisplayView("fail");
        });
    };
    return FormItemTradesmen;
}(Base));
export { FormItemTradesmen };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-tradesmen/form-item-tradesmen.component.ts
// module id = 1099
// module chunks = 0